import { ActivitiesAggrigatorModel } from "@shared/model/activities-aggrigator-model";
import { ActivityVerbEnum } from "@shared/model/enum/activity-verb-enum";
import { ObjectTypeEnum } from "@shared/model/enum/object-type-enum";
import { htmlUrls } from "@shared/utils/router-paths";

export function getOnClickUrl(
    siteUrl: string,
    activity: ActivitiesAggrigatorModel
): string {
    const verb = activity?.verb;
    const objectType = activity?.inDirectObject?.objectType ?? ObjectTypeEnum.Post;
    const objectId = activity?.inDirectObject?.objectId ?? '';
    const dataId = activity?.inDirectObject?.data?.id ?? '';


    // Handles URL generation based on the activity's verb and object type.
    // Each 'verb' ( Commented, Liked, Reacted) defines a category of user action.
    // Inside each verb, we check the related object type (like Post, Review, Quote, etc.)
    // to build the correct URL for redirection when the notification is clicked.


    switch (verb) {
        //  Comment-related URLs
        case ActivityVerbEnum.Commented:
            switch (objectType) {
                case ObjectTypeEnum.Post:
                    return `${siteUrl}${htmlUrls.post}${objectId}`;
                case ObjectTypeEnum.Progress:
                    return `${siteUrl}${htmlUrls.states}${objectId}`;
                case ObjectTypeEnum.Review:
                    return `${siteUrl}${htmlUrls.reviews}${objectId}`;
                case ObjectTypeEnum.Booklist:
                    {
                        if (activity?.inDirectObject?.data === null) return ''
                        return `${siteUrl}${htmlUrls.comment_booklist}${objectId}`
                    };
                case ObjectTypeEnum.Quote:
                    return `${siteUrl}${htmlUrls.quote}${dataId}`;
                case ObjectTypeEnum.UserChallenge:
                    return `${siteUrl}${htmlUrls.challenge_detail}${objectId}`;
                case ObjectTypeEnum.badge:
                    return `${siteUrl}${htmlUrls.achieved_badge}${objectId}`;
                case ObjectTypeEnum.Club:
                    return `${siteUrl}${htmlUrls.intro_club}${objectId}`;
                case ObjectTypeEnum.UserReportPublished:
                    return `${siteUrl}${htmlUrls.annual_report}${objectId}`;
                default:
                    return siteUrl;
            }

        // Like-related URLs
        case ActivityVerbEnum.Liked:
            switch (objectType) {
                case ObjectTypeEnum.Review:
                    return `${siteUrl}${htmlUrls.reviews}${objectId}`;
                case ObjectTypeEnum.Quote:
                    return `${siteUrl}${htmlUrls.quote}${dataId}`;
                case ObjectTypeEnum.Progress:
                    return `${siteUrl}${htmlUrls.book}${objectId}`;
                case ObjectTypeEnum.Post:
                    return `${siteUrl}${htmlUrls.post}${objectId}`;
                case ObjectTypeEnum.Booklist:
                    {
                        if (activity?.inDirectObject?.data === null) return ''
                        return `${siteUrl}${htmlUrls.bookList}${objectId}`
                    };
                case ObjectTypeEnum.Club:
                    return `${siteUrl}${htmlUrls.intro_club}${objectId}`;
                case ObjectTypeEnum.badge:
                    return `${siteUrl}${htmlUrls.achieved_badge}${objectId}`;
                case ObjectTypeEnum.UserReportPublished:
                    return `${siteUrl}${htmlUrls.annual_report}${objectId}`;
                case ObjectTypeEnum.UserChallenge:
                    return `${siteUrl}${htmlUrls.challenges_achieved}${objectId}`;

                default:
                    return siteUrl;
            }

        // Reacted-related URLs
        case ActivityVerbEnum.Reacted:
            switch (objectType) {
                case ObjectTypeEnum.Review:
                    return `${siteUrl}${htmlUrls.reviews}${objectId}`;
                case ObjectTypeEnum.Progress:
                    return `${siteUrl}${htmlUrls.states}${objectId}`;
                case ObjectTypeEnum.Booklist:
                    {
                        if (activity?.inDirectObject?.data === null) return ''
                        return `${siteUrl}${htmlUrls.bookList}${objectId}`
                    };
                case ObjectTypeEnum.Quote:
                    return `${siteUrl}${htmlUrls.quote}${objectId}`;
                case ObjectTypeEnum.Post:
                    return `${siteUrl}${htmlUrls.post}${objectId}`;
                case ObjectTypeEnum.Challenge:
                    return `${siteUrl}${htmlUrls.challenge_detail}${objectId}`;
                case ObjectTypeEnum.Club:
                    return `${siteUrl}${htmlUrls.intro_club}${objectId}`;
                case ObjectTypeEnum.badge:
                    return `${siteUrl}${htmlUrls.achieved_badge}${objectId}`;

                default:
                    return siteUrl;

            }

        case ActivityVerbEnum.Reviewed:
            return `${siteUrl}${htmlUrls.review}${activity.inDirectObject?.data.id}`;

        case ActivityVerbEnum.Quoted:
            return `${siteUrl}${htmlUrls.quote}${dataId}`;

        case ActivityVerbEnum.Posted:
            return `${siteUrl}${htmlUrls.post}${dataId}`;

        case ActivityVerbEnum.ClubInvited:
            return `${siteUrl}${htmlUrls.club}${dataId}`;

        case ActivityVerbEnum.ClubJoinRequested:
            return `${siteUrl}${htmlUrls.edit_club}${dataId}`;

        case ActivityVerbEnum.Coursed:
            return `${siteUrl}${htmlUrls.course_details}${dataId}`;

        case ActivityVerbEnum.CourseEnded:
            return `${siteUrl}${htmlUrls.course_details}${dataId}`;

        case ActivityVerbEnum.Polled:
            return `${siteUrl}${htmlUrls.detail_poll}${dataId}`;

        case ActivityVerbEnum.PollClosed:
            return `${siteUrl}${htmlUrls.detail_poll}${dataId}`;

        case ActivityVerbEnum.Meetinged:
            {
                if (activity?.inDirectObject === null) return ''
                return `${siteUrl}${htmlUrls.meeting}${dataId}`;
            }

        case ActivityVerbEnum.ClubJoinRequestAccepted:
            return `${siteUrl}${htmlUrls.edit_club}${dataId}`;

        case ActivityVerbEnum.ChallengeObtained:
            return `${siteUrl}${htmlUrls.challenges_achieved}${objectId}`;

        case ActivityVerbEnum.AchievementObtained:
            return `${siteUrl}${htmlUrls.achieved_badge}${objectId}`;

        case ActivityVerbEnum.Reminder:
            return `${siteUrl}${htmlUrls.challenges_progress}`;

        case ActivityVerbEnum.BookRequestAccepted:
            return `${siteUrl}${htmlUrls.book}${activity?.object?.data?.book?.id}`;

        case ActivityVerbEnum.ChallengeFailed:
            return `${siteUrl}${htmlUrls.challenge_detail}${dataId}`;

        case ActivityVerbEnum.FollowRequested:
            return `${siteUrl}${htmlUrls.notifications}`;

        default:
            return siteUrl;
    }
}